import React, { Component, Fragment } from "react";
import { Row, Container, Col, TabContent, TabPane, Nav, NavItem, NavLink, Button } from "reactstrap";
import ShutterDesign from "./ShutterDesign";
import ManuallyGates from "./ManuallyGates";
import ElectricallyGates from "./ElectricallyGates";
import classnames from 'classnames';
import $ from 'jquery';
import GridListing from "./GridListing";
import YokeDesign from "./YokeDesign";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { searchableSelect, renderSelectField, renderText, focusOnError, InputHiddenField, renderNumberInputField, renderDatePicker } from "../layout/FormInputs";
import { connect } from "react-redux";
import { maxLength70, minLength5, maxLength25, required, email, checkForNull } from "../../helper/validation";
import Report from "./Report";

const initialData = {
    height: '',
    seatingHead: '',
    unseatingHead: '',
    width: '',
    stemDia: '',
    cl_pl: '',
    shaftSpindle: '',
    SpindleDirection: '',
    frameMounting: '',
    ClosureType: '',
    Actuation: '',
    SelectedSeriesOffered: '',
    SelectedFrameLengthType: '',
    HRb1: '',
    HRd: '',
    HRt1: '',
    HRt3: '',
    HRd1: '',
    HRD: '',
    VRb1: '',
    VRt1: '',
    VRd1: '',
    VRD: '',
    VRt3: '',
    VRd: '',
    referenceDocuments: 0,
    manufacturingMaterial: 0,
    horizontalStiffenersSection: 'A',
    verticalStiffenersSection: 'A',
    verticalStiffeners: '',
    horizontalStiffeners: '',
    skinPlateThickness: '',
    horizontalDeflection: '',
    verticalDeflection: '',
}

class DesignMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            activeTab: '1',
            isEditFlag: false,
            ShutterId: '',
            isActiveManualActuation: false,
            isActiveElectricActuation: false,
            data: initialData,
            shutterDesignData: {},
            selectedActuation: 'MANUAL',
            manuallyHoistingCapacity: '',
            electricallyHoistingCapacity: '',
            setSafteyFactor: '',
            criticalBulkingForce: '',
            width: 0,
            applicableStandard: 'AWWA-C561',
            isReportActive: false,
            addNewFlag: false,
            selectedShutterDesignData: '',
            isViewFlag: false,
            shutterDesignCreated: false,
            manualDesignCreated: false,
            electricalDesignCreated: false
        };
    }

    /**
     * @method openModel
     * @description  used to open filter form 
     */
    openModel = () => {
        this.setState({ isOpen: true })
    }

    /**
     * @method onCancel
     * @description  used to cancel filter form
     */
    onCancel = () => {
        this.setState({ isOpen: false })
    }

    /**
    * @method toggle
    * @description toggling the tabs
    */
    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    /**
    * @method toggle
    * @description toggling the tabs
    */
    cancleToggle = (tab) => {
        this.setState({
            data: '',
            isReportActive: false,
            addNewFlag: false,
            isActiveManualActuation: false,
            isActiveElectricActuation: false,
            isEditFlag: false,
            isViewFlag: false,
            ShutterId: '',
            manualDesignCreated: false,
            electricalDesignCreated: false,
            shutterDesignCreated: false,
        })
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    shutterDetail = (data) => {
        if (data && data.isEditFlag) {
            this.setState({
                isEditFlag: data.isEditFlag,
                ShutterId: data.ShutterId,
                activeTab: '2',
            })
        }
    }

    shutterIdNewCreated = (Id) => {
        this.setState({ ShutterId: Id })
    }

    ActuationToggler = (activeActuation) => {
        this.setState({ selectedActuation: activeActuation })
        if (activeActuation == 'MANUAL') {
            this.setState({
                isActiveManualActuation: true,
                isActiveElectricActuation: false,
            })
        } else {
            this.setState({
                isActiveManualActuation: false,
                isActiveElectricActuation: true,
            })
        }
    }

    topFunction = () => {
        $('html, body').animate({ scrollTop: 0 }, 800);
        //document.body.scrollTop = 0; // For Safari
        //document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    addNewCosting = () => {
        this.setState({
            data: initialData,
            addNewFlag: true
        })
        this.toggle('2')
    }

    onSubmit = () => { }

    resetTabs = () => this.setState({ addNewFlag: false, isEditFlag: false, isViewFlag: false })

    render() {
        const { handleSubmit, reset, pristine, submitting, fieldObj } = this.props;
        const { addNewFlag, isEditFlag, isViewFlag } = this.state;

        return (
            <div>
                <div className="user-page">
                    <div>
                        <Container fluid className="cr-searchlisting-container cr-table-wrap">
                            <Row>
                                <Col md="6" className="form-heading">
                                    <h2>Design Module</h2>
                                </Col>
                                {this.state.activeTab === '1' ? <Col md="6">
                                    <button
                                        type={'button'}
                                        className={'btn btn-primary pull-right mt30'}
                                        onClick={this.addNewCosting}
                                    ><div class="plus"></div> ADD NEW DESIGN</button>
                                </Col> :
                                    <Col md="6">
                                        <button
                                            type={'button'}
                                            className={'btn btn-primary pull-right mt30'}
                                            onClick={() => {
                                                this.toggle('1')
                                                this.setState({
                                                    data: '',
                                                    isReportActive: false,
                                                    addNewFlag: false,
                                                    isActiveManualActuation: false,
                                                    isActiveElectricActuation: false,
                                                    isEditFlag: false,
                                                    isViewFlag: false,
                                                    ShutterId: '',
                                                    manualDesignCreated: false,
                                                    electricalDesignCreated: false,
                                                    shutterDesignCreated: false,
                                                })
                                            }}
                                        > Cancel </button>
                                    </Col>
                                }
                            </Row>

                            <Nav tabs className="subtabs">
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => {
                                        this.toggle('1');
                                        this.setState({
                                            isReportActive: false,
                                            addNewFlag: false,
                                            isActiveManualActuation: false,
                                            isActiveElectricActuation: false,
                                            isEditFlag: false,
                                            isViewFlag: false,
                                            ShutterId: '',
                                            manualDesignCreated: false,
                                            electricalDesignCreated: false,
                                            shutterDesignCreated: false,
                                        })
                                    }}>
                                        Search Costing
                                    </NavLink>
                                </NavItem>
                                {(addNewFlag || isEditFlag || isViewFlag) &&
                                    <>
                                        <NavItem>
                                            <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => {
                                                this.toggle('2');
                                                this.setState({ isReportActive: false })
                                            }}>
                                                Shutter Design
                                            </NavLink>
                                        </NavItem>
                                        {this.state.isActiveManualActuation &&
                                            <NavItem>
                                                <NavLink className={classnames({ active: this.state.activeTab === '3' })} onClick={() => {
                                                    this.toggle('3');
                                                    this.setState({ isReportActive: false })
                                                }}>
                                                    Manually Operated
                                                </NavLink>
                                            </NavItem>}
                                        {this.state.isActiveElectricActuation &&
                                            <NavItem>
                                                <NavLink className={classnames({ active: this.state.activeTab === '4' })} onClick={() => {
                                                    this.toggle('4');
                                                    this.setState({ isReportActive: false })
                                                }}>
                                                    Electrically Operated
                                                </NavLink>
                                            </NavItem>}

                                        {(this.state.isActiveManualActuation || this.state.isActiveElectricActuation) &&
                                            <NavItem>
                                                <NavLink className={classnames({ active: this.state.activeTab === '5' })} onClick={() => {
                                                    this.toggle('5');
                                                    this.setState({ isReportActive: false })
                                                }}>
                                                    Yoke Design
                                                </NavLink>
                                            </NavItem>}

                                    </>
                                }
                                {(this.state.isReportActive) &&
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.state.activeTab === '6' })} onClick={() => { this.toggle('6'); }}>
                                            Report
                                        </NavLink>
                                    </NavItem>}
                            </Nav>
                            {/* <form
                            noValidate
                            className="form"
                            onSubmit={handleSubmit(this.onSubmit.bind(this))}
                        >
                            
                        </form> */}
                        </Container>
                        <TabContent activeTab={this.state.activeTab} className="cir-tab-container">
                            {this.state.activeTab === '1' &&
                                <TabPane tabId="1">
                                    <GridListing
                                        toggle={this.toggle}
                                        shutterDetail={this.shutterDetail}
                                        showReportTab={(val, data) => this.setState({ isReportActive: val, selectedShutterDesignData: data })}
                                        viewDesign={(value, data) => this.setState({ isViewFlag: value, ShutterId: data.ShutterDesignCalculationId, })}
                                    // setData={(value) => this.setState({ data: value })}
                                    // setShutterDesignData={(value) => this.setState({ shutterDesignData: value })}
                                    // shutterDesignData={this.state.shutterDesignData}
                                    // data={this.state.data}
                                    />
                                </TabPane>
                            }
                            {this.state.activeTab === '2' &&
                                <TabPane tabId="2">
                                    <ShutterDesign
                                        toggle={this.toggle}
                                        cancleToggle={this.cancleToggle}
                                        setData={(value) => this.setState({ data: value })}
                                        setShutterDesignData={(value) => this.setState({ shutterDesignData: value })}
                                        shutterDesignData={this.state.shutterDesignData}
                                        data={this.state.data}
                                        isEditFlag={this.state.isEditFlag}
                                        ShutterId={this.state.ShutterId}
                                        ActuationToggler={this.ActuationToggler}
                                        shutterIdNewCreated={this.shutterIdNewCreated}
                                        setWidth={(value => this.setState({ width: value }))}
                                        isViewFlag={isViewFlag}
                                        shutterDesignCreated={this.state.shutterDesignCreated}
                                        setShutterDesignCreated={(value) => this.setState({ shutterDesignCreated: value })}
                                    // setApplicableStandard={(value) => this.setState({applicableStandard: value})}
                                    />
                                </TabPane>
                            }
                            {this.state.activeTab === '3' &&
                                this.state.isActiveManualActuation &&
                                <TabPane tabId="3">
                                    <ManuallyGates
                                        toggle={this.toggle}
                                        // data={this.state.data}
                                        tab={this.state.activeTab}
                                        shutterDesignData={this.state.shutterDesignData}
                                        setSafteyFactor={(value) => this.setState({ setSafteyFactor: value })}
                                        isEditFlag={this.state.isEditFlag}
                                        ShutterId={this.state.ShutterId}
                                        setHoistingCapacity={(value) => this.setState({ manuallyHoistingCapacity: value })}
                                        isViewFlag={isViewFlag}
                                        manualDesignCreated={this.state.manualDesignCreated}
                                        setManualDesignCreated={(value) => this.setState({ manualDesignCreated: value })}
                                    />
                                </TabPane>
                            }
                            {this.state.activeTab === '4' &&
                                this.state.isActiveElectricActuation &&
                                <TabPane tabId="4">
                                    <ElectricallyGates
                                        toggle={this.toggle}
                                        // data={this.state.data}
                                        shutterDesignData={this.state.shutterDesignData}
                                        tab={this.state.activeTab}
                                        isEditFlag={this.state.isEditFlag}
                                        setHoistingCapacity={(value) => this.setState({ electricallyHoistingCapacity: value })}
                                        ShutterId={this.state.ShutterId}
                                        setCriticalBulkingForceValue={(value) => this.setState({ criticalBulkingForce: value })}
                                        setWidth={(value => this.setState({ width: value }))}
                                        isViewFlag={isViewFlag}
                                        electricalDesignCreated={this.state.electricalDesignCreated}
                                        setElectricDesignCreated={(value) => this.setState({ electricalDesignCreated: value })}
                                    />
                                </TabPane>
                            }
                            {this.state.activeTab === '5' && <TabPane tabId="5">
                                <YokeDesign
                                    toggle={this.toggle}
                                    // data={this.state.data}
                                    shutterDesignData={this.state.shutterDesignData}
                                    isEditFlag={this.state.isEditFlag}
                                    manuallyHoistingCapacity={this.state.manuallyHoistingCapacity}
                                    safetyFactor={this.state.setSafteyFactor}
                                    electricallyHoistingCapacity={this.state.electricallyHoistingCapacity}
                                    tab={this.state.activeTab}
                                    ShutterId={this.state.ShutterId}
                                    selectedActuation={this.state.selectedActuation}
                                    shutterIdNewCreated={this.shutterIdNewCreated}
                                    criticalBulkingForce={this.state.criticalBulkingForce}
                                    width={this.state.width}
                                    applicableStandard={this.state.applicableStandard}
                                    resetTabs={() => this.resetTabs()}
                                    isViewFlag={isViewFlag}
                                />
                            </TabPane>
                            }
                            {this.state.activeTab === '6' &&
                                <TabPane tabId="6">
                                    <Report
                                        toggle={this.toggle}
                                        selectedShutterDesignData={this.state.selectedShutterDesignData}
                                        activeTab={this.state.activeTab}
                                        data={this.state.data}
                                        shutterDesignData={this.state.shutterDesignData}
                                        showReportTab={(val) => this.setState({ isReportActive: val })}
                                    />
                                </TabPane>
                            }
                        </TabContent>
                    </div>
                </div>
                <div className="cr-backtotop">
                    <button
                        type="button"
                        className={'go-top-button'}
                        onClick={this.topFunction}
                    >
                        <i class="fa fa-arrow-up" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        );
    }
}

/**
* Form validations
* @param values
* @returns {{}}
        */
const validate = values => {
    let errors = {};

    return errors;
};

/**
* @method connect
* @description connect with redux
* @param {function} mapStateToProps
* @param {function} mapDispatchToProps
*/
export default connect(null, null)(reduxForm({
    form: 'designMaster',
    onSubmitFail: errors => {
        focusOnError(errors);
    },
    enableReinitialize: true,
})(DesignMaster));
